function limitColorSwatches() {
    console.log("Limiting color swatches to 2 lines");
  
    const cards = document.querySelectorAll(".product-card");
    console.log("Nombre de cartes produits détectées :", cards.length);
  
    cards.forEach((card, cardIndex) => {
      const fieldset = card.querySelector(".h-stack.wrap");
      if (!fieldset) return;
      
      const labels = card.querySelectorAll(".color-swatch");
      console.log(`Carte ${cardIndex + 1}: Nombre de color-swatches détectés:`, labels.length);
  
      if (labels.length === 0) return;
      
      // Rendre tous les swatches visibles temporairement pour calculer les lignes
      labels.forEach(label => label.style.display = "");
      
      // Supprimer l'ancien bouton "..." s'il existe
      const oldMoreLabel = fieldset.querySelector(".swatch-more-button");
      if (oldMoreLabel) oldMoreLabel.remove();
      
      // Calculer quels swatches sont sur les 2 premières lignes
      const firstSwatchTop = labels[0].offsetTop;
      let maxVisibleIndex = labels.length;
      let secondLineTop = null;
      
      for (let i = 1; i < labels.length; i++) {
        const currentTop = labels[i].offsetTop;
        
        // Détection de la deuxième ligne
        if (secondLineTop === null && currentTop > firstSwatchTop) {
          secondLineTop = currentTop;
        }
        
        // Si on dépasse la deuxième ligne, on arrête
        if (secondLineTop !== null && currentTop > secondLineTop) {
          maxVisibleIndex = i;
          break;
        }
      }
  
      // Afficher les "..." si nécessaire, en REMPLACEMENT du dernier de la 2ème ligne
      if (labels.length > maxVisibleIndex && maxVisibleIndex > 0) {
        // On cache un swatch de plus pour faire de la place au "..."
        maxVisibleIndex = maxVisibleIndex - 1;
        
        const moreLabel = document.createElement("span");
        moreLabel.className = "swatch-more-button";
        moreLabel.textContent = "...";
        moreLabel.style.cursor = "pointer";
        moreLabel.style.marginLeft = "10px";
        moreLabel.style.fontWeight = "bold";
        moreLabel.style.alignSelf = "center";
  
        // Insère le bouton "..." à la place du dernier swatch visible
        labels[maxVisibleIndex].after(moreLabel);
  
        moreLabel.addEventListener("click", function () {
          labels.forEach((label) => (label.style.display = "")); // Révèle tous les swatches
          moreLabel.remove(); // Supprime le bouton "..."
        });
      }
      
      // Cache les swatches au-delà des 2 premières lignes (incluant celui remplacé par "...")
      labels.forEach((label, index) => {
        if (index >= maxVisibleIndex) {
          console.log(`Caché: swatch index ${index}`);
          label.style.display = "none";
        }
      });
    });
  }
  
  
  // Appel initial au chargement de la page
  document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded and parsed");
    setTimeout(() => {
      limitColorSwatches();  
    }, 500);
    
  });
  
  // Appel lors de l'événement de filtrage identifié (exemple)
  document.addEventListener("facet:update", function () {
    console.log("Shopify section loaded, reloading color swatches");
    setTimeout(() => {
        limitColorSwatches();    
    }, 500);
    
  });
  
  // Recalculer lors du redimensionnement (changement de mode d'affichage de la collection)
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      console.log("Window resized, recalculating color swatches");
      limitColorSwatches();
    }, 250);
  });
  

/********************************************** */

document.addEventListener('DOMContentLoaded', function () {
  const DBG_ACTIVE = false;
	const DBG_PREFIX = '[BYMOI_POPUP]';
	const swatches = document.querySelectorAll('.color-swatch');
	let activeByMoiPopup = null;

	function dbg() {
    if (!DBG_ACTIVE) return ;
		const args = Array.prototype.slice.call(arguments);
		console.log.apply(console, [DBG_PREFIX].concat(args));
	}

	function isDesktopHoverMode() {
		const result = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
		dbg('isDesktopHoverMode ->', result);
		return result;
	}

	function openPopup(popup, reason, popupId) {
		dbg('OPEN', { reason: reason, popupId: popupId, beforeDisplay: popup.style.display || '(empty)' });
		popup.style.display = 'flex';
		popup.style.position = 'absolute';
		dbg('OPEN_DONE', { popupId: popupId, afterDisplay: popup.style.display });
	}

	function closePopup(popup, reason, popupId) {
		dbg('CLOSE', { reason: reason, popupId: popupId, beforeDisplay: popup.style.display || '(empty)' });
		popup.style.display = 'none';
		dbg('CLOSE_DONE', { popupId: popupId, afterDisplay: popup.style.display });
	}

	function closeActiveByMoiPopup(reason) {
		if (activeByMoiPopup) {
			const popupId = activeByMoiPopup.getAttribute('data-id');
			dbg('CLOSE_ACTIVE', { reason: reason, popupId: popupId });
			closePopup(activeByMoiPopup, reason, popupId);
			activeByMoiPopup = null;
		} else {
			dbg('CLOSE_ACTIVE_SKIPPED', { reason: reason, message: 'no active popup' });
		}
	}

	dbg('INIT', { swatchesCount: swatches.length });

	swatches.forEach(function (swatch) {
		const popupId = swatch.getAttribute('for');
		if (!popupId) {
			dbg('SWATCH_SKIP_NO_FOR');
			return;
		}

		const popup = document.querySelector('.swatch-zoom-popup[data-id="' + popupId + '"]');
		if (!popup) {
			console.log('Popup introuvable pour data-id :', popupId);
			dbg('SWATCH_SKIP_NO_POPUP', { popupId: popupId });
			return;
		}

		const isByMoiSwatch = swatch.getAttribute('data-by-moi-swatch') === 'true';
		dbg('SWATCH_BIND', { popupId: popupId, isByMoiSwatch: isByMoiSwatch });

		// Desktop behavior remains unchanged.
		swatch.addEventListener('mouseenter', function () {
			if (isByMoiSwatch && !isDesktopHoverMode()) {
				dbg('MOUSEENTER_IGNORED_NON_DESKTOP', { popupId: popupId });
				return;
			}
			dbg('EVENT mouseenter', { popupId: popupId });
			openPopup(popup, 'mouseenter', popupId);
			if (isByMoiSwatch) activeByMoiPopup = popup;
			if (isByMoiSwatch) dbg('ACTIVE_SET', { popupId: popupId, reason: 'mouseenter' });
		});

		swatch.addEventListener('mousemove', function () {
			if (isByMoiSwatch && !isDesktopHoverMode()) {
				dbg('MOUSEMOVE_IGNORED_NON_DESKTOP', { popupId: popupId });
				return;
			}
			dbg('EVENT mousemove', { popupId: popupId });
			// Keep current behavior (no custom move logic).
		});

		swatch.addEventListener('mouseleave', function () {
			if (isByMoiSwatch && !isDesktopHoverMode()) {
				dbg('MOUSELEAVE_IGNORED_NON_DESKTOP', { popupId: popupId });
				return;
			}
			dbg('EVENT mouseleave', { popupId: popupId });
			closePopup(popup, 'mouseleave', popupId);
			if (activeByMoiPopup === popup) activeByMoiPopup = null;
			if (activeByMoiPopup === null) dbg('ACTIVE_CLEARED', { popupId: popupId, reason: 'mouseleave' });
		});

		// Mobile behavior enhancements apply only to By Moi swatches.
		if (isByMoiSwatch) {
			swatch.addEventListener('click', function (e) {
				dbg('EVENT click', { popupId: popupId, targetClass: e.target && e.target.className });
				if (isDesktopHoverMode()) {
					dbg('CLICK_IGNORED_DESKTOP_MODE', { popupId: popupId });
					return;
				}

				const isSameActivePopup = activeByMoiPopup === popup;
				dbg('CLICK_STATE', {
					popupId: popupId,
					currentDisplay: popup.style.display || '(empty)',
					isSameActivePopup: isSameActivePopup
				});

				if (!isSameActivePopup) {
					closeActiveByMoiPopup('mobile-click-before-open');
				}

				// Always ensure popup is open after a mobile tap on this swatch.
				openPopup(popup, 'mobile-click-open', popupId);
				activeByMoiPopup = popup;
				dbg('ACTIVE_SET', { popupId: popupId, reason: 'mobile-click-open' });

				// Avoid immediate close from the document click handler.
				e.stopPropagation();
				dbg('CLICK_STOP_PROPAGATION', { popupId: popupId });
			});
		}
	});

	// Tap outside: close active By Moi popup on mobile.
	document.addEventListener('click', function (e) {
		dbg('EVENT document-click', { targetClass: e.target && e.target.className });
		if (isDesktopHoverMode()) {
			dbg('DOC_CLICK_IGNORED_DESKTOP_MODE');
			return;
		}
		if (!activeByMoiPopup) {
			dbg('DOC_CLICK_NO_ACTIVE_POPUP');
			return;
		}

		const inByMoiSwatch = e.target.closest('[data-by-moi-swatch="true"]');
		const inByMoiSwatchWrapper = e.target.closest('.variant-picker__option-values_cbm');
		const inByMoiInput = e.target.closest('.swatch-input__input');
		const inByMoiPopup = e.target.closest('.swatch-zoom-popup[data-by-moi-popup="true"]');
		dbg('DOC_CLICK_ZONE_CHECK', {
			inByMoiSwatch: !!inByMoiSwatch,
			inByMoiSwatchWrapper: !!inByMoiSwatchWrapper,
			inByMoiInput: !!inByMoiInput,
			inByMoiPopup: !!inByMoiPopup
		});

		if (!inByMoiSwatch && !inByMoiSwatchWrapper && !inByMoiInput && !inByMoiPopup) {
			closeActiveByMoiPopup('document-click-outside');
		} else {
			dbg('DOC_CLICK_INSIDE_BY_MOI_ZONE_KEEP_OPEN');
		}
	});

	// Scroll: close active By Moi popup on mobile.
	window.addEventListener(
		'scroll',
		function () {
			dbg('EVENT window-scroll');
			if (isDesktopHoverMode()) {
				dbg('SCROLL_IGNORED_DESKTOP_MODE');
				return;
			}
			closeActiveByMoiPopup('window-scroll');
		},
		{ passive: true }
	);

	// Resize/orientation: close active By Moi popup on mobile.
	window.addEventListener('resize', function () {
		dbg('EVENT window-resize');
		if (isDesktopHoverMode()) {
			dbg('RESIZE_IGNORED_DESKTOP_MODE');
			return;
		}
		closeActiveByMoiPopup('window-resize');
	});
});


